import axios from 'axios';
import { captureException } from '@sentry/react';

import {
  LOCAL_STORAGE_DATA_KEY,
  OUT_OF_STOCK_ERROR_VIEW,
  OUT_OF_STOCK_FORM_ERROR,
  OUT_OF_STOCK_FORM_SUCCESS,
  OUT_OF_STOCK_FORM_VIEW,
  OUT_OF_STOCK_POPUP_STATE_CLOSE,
  OUT_OF_STOCK_POPUP_STATE_OPEN,
  OUT_OF_STOCK_SENT,
  OUT_OF_STOCK_STORAGE_DATA,
  OUT_OF_STOCK_SUCCESS_VIEW,
  TOOGLE_AGREEMENT_FIELD_DATA,
} from './constants';
import {
  getOutOfStockArticle,
  getOutOfStockProductArticle,
  getOutOfStockProductId,
} from './selectors';

export const openOutOfStockPopup = (productId, article) => (dispatch) => {
  dispatch({
    article,
    outOfStockOpenState: true,
    productId,
    type: OUT_OF_STOCK_POPUP_STATE_OPEN,
    viewState: OUT_OF_STOCK_FORM_VIEW,
  });
};

export const outOfStockSent = () => (dispatch) => {
  dispatch({
    type: OUT_OF_STOCK_SENT,
  });
};

export const closeOutOfStockPopup = () => (dispatch) => {
  dispatch({
    outOfStockOpenState: false,
    type: OUT_OF_STOCK_POPUP_STATE_CLOSE,
  });
};

export const toggleAgreementCheckbox = (value) => (dispatch) => {
  dispatch({
    payload: value,
    type: TOOGLE_AGREEMENT_FIELD_DATA,
  });
};

export const sendAntiforgeryRequest = (onSuccess, onError) => {
  axios({
    data: null,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    method: 'post',
    responseType: 'json',
    url: '/shop/basket/antiforgeryrequestjson/',
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      captureException(error);
      onError(error);
    });
};

export const submitOutOfStockForm = (data) => (dispatch, getState) => {
  const state = getState();
  const { article, email, id, name: fullname } = data;
  const productId = id || getOutOfStockProductId(state);
  // TODO разобраться с артикулами в каталоге и рекомендациях
  const articlePopup = getOutOfStockProductArticle(state) || getOutOfStockArticle(state);

  const onError = (message) => {
    // Ошибка при подписке на поступление товара
    // dispatch(errorSubscribeOutOfStockProduct(productId));
    dispatch({
      message,
      outOfStockOpenState: false,
      type: OUT_OF_STOCK_FORM_ERROR,
      viewState: OUT_OF_STOCK_ERROR_VIEW,
    });
  };
  sendAntiforgeryRequest((antiforgeryData) => {
    const { _RequestVerificationToken } = antiforgeryData.data || {};
    axios({
      data: {
        article: article || articlePopup,
        email,
        fullname,
      },
      headers: {
        __RequestVerificationToken: _RequestVerificationToken,
        'X-Requested-With': 'XMLHttpRequest',
      },
      method: 'post',
      responseType: 'json',
      url: '/shop/admission/',
    })
      .then((response) => {
        const responseData = response.data || {};
        if (responseData.IsSucceeded) {
          dispatch({
            productId,
            type: OUT_OF_STOCK_FORM_SUCCESS,
            viewState: OUT_OF_STOCK_SUCCESS_VIEW,
          });

          // dispatch(subscribeOutOfStockProduct(productId));
          setProductIdInStorage(productId, (storageData) => {
            dispatch({
              payload: storageData,
              type: OUT_OF_STOCK_STORAGE_DATA,
            });
          });
        } else {
          onError(responseData.message);
        }
      })
      .catch(onError);
  }, onError);
};

export const setProductIdInStorage = (productId, callback) => {
  const storage = (window || {}).localStorage;
  const outofstockList = JSON.parse(storage.getItem(LOCAL_STORAGE_DATA_KEY)) || [];
  // Добавить айди в массив только если его там нет
  if (!outofstockList.find((id) => id === productId)) {
    outofstockList.push(productId);
  }
  storage.setItem(LOCAL_STORAGE_DATA_KEY, JSON.stringify(outofstockList));
  if (callback) {
    callback(JSON.stringify(outofstockList));
  }
};
